// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__x1JUZ","subHeaderText":"styles_subHeaderText__PMjRv","illustration":"styles_illustration__uUNW6"};